import { render, staticRenderFns } from "./SelectorFornecedor.vue?vue&type=template&id=e90eca58&scoped=true"
import script from "./SelectorFornecedor.vue?vue&type=script&lang=js"
export * from "./SelectorFornecedor.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./SelectorFornecedor.vue?vue&type=style&index=2&id=e90eca58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90eca58",
  null
  
)

export default component.exports